<ng-template
#preview
let-preview
>
<tui-preview
    [rotatable]="false"
    [zoomable]="false"
>
    <div class="relative">
        <button
            iconStart="@tui.x"
            tuiIconButton
            type="button"
            (click)="close(preview)"
            style="position: absolute; right: -36px; top: 0px; border-radius: 3rem; height: 30px;width: 30px;"
        >
            Close
        </button>
        <iframe
            allowfullscreen
            frameborder="0"
            style="height: 100vh;width: 100vw; background-color: white;"
            [src]="link | safe"
        ></iframe>
        <div class="price-conversion">
            {{price}}
        </div>
    </div>
</tui-preview>
</ng-template>